<template>
  <div class="bg-white">
    <el-row type="flex" justify="end" class="pt-1">
      <el-col :sm="12">
        <el-form
          class="text-right"
          :inline="true"
          @submit.native.prevent="fetch(1)"
          size="small"
        >
          <el-form-item>
            <!-- <el-input
              v-model="pager.search"
              placeholder="Search..."
              clearable
            ></el-input> -->
            <el-select
              v-model="pager.search"
              placeholder="Search..."
              filterable
              @change="fetch"
            >
              <el-option
                v-for="item in glossary"
                :key="item.id"
                :value="item.part_no"
                :label="item.part_no"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="fetch(1)">Search</el-button>
            <el-button :disabled="list.data.length == 0" size="small" type="primary" @click="download" >Download</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-table
      :data="list.data"
      v-loading="isLoading"
      ref="dataTable"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="45" :selectable="verify">
      </el-table-column>
      <el-table-column label="Actions" width="190" v-if="validateAccess()">
        <template slot-scope="scope">
          <router-link
            title="View Request"
            class="el-button el-button--primary el-button--small is-circle"
            :to="{ name: 'request_info', params: { id: scope.row.id } }"
            ><i class="el-icon-folder-opened"></i>
          </router-link>
          <el-button
            title="Delete Request"
            icon="el-icon-delete"
            circle
            size="small"
            type="danger"
            @click="deleteRequest(scope.row.id)"
          >
          </el-button>
          <template v-if="scope.row.request_status == 'For Approval'">
            <el-button
              title="Approve Request"
              @click="itemApprove(scope.row, 1)"
              size="small"
              type="success"
              icon="el-icon-check"
              circle
            ></el-button>
            <el-button
              title="Decline Request"
              @click="itemApprove(scope.row, 2)"
              size="small"
              type="danger"
              icon="el-icon-close"
              circle
            ></el-button>
          </template>
        </template>
      </el-table-column>
      <el-table-column label="Part No." prop="part_no" />
      <el-table-column label="Description" width="250" prop="description" />
      <el-table-column label="Quantity" prop="quantity">
        <template slot-scope="scope">
          <span>{{ scope.row.quantity | number("0,0") }}</span>
        </template>
      </el-table-column>
      <el-table-column label="Status" prop="request_status" />
      <el-table-column min-width="120" label="Requested By" prop="username" />
      <el-table-column label="Date Requested" min-width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.requested_date | dateFormat }}</span>
        </template>
      </el-table-column>
    </el-table>
    <el-row :gutter="15">
      <el-col :sm="12">
        <el-pagination
          v-show="list.data.length != 0"
          class="pt-1 pb-1"
          background
          layout="prev, pager, next"
          :total="list.paging.total"
          :page-size="pager.limit"
          :current-page="parseInt(list.paging.cur_page)"
          @current-change="fetch"
        ></el-pagination>
      </el-col>
      <el-col :sm="12">
        <div class="text-right pt-1 pr-1" v-show="isWithSelection">
          <el-button
            v-if="false"
            v-show="isWithSelection"
            type="danger"
            size="mini"
            @click="deleteMultiple"
            >Bulk Delete</el-button
          >
          <template v-if="is_admin">
            <el-button type="primary" size="mini" @click="bulkApprove(1)"
              >Bulk Approve</el-button
            >
            <el-button type="danger" size="mini" @click="bulkApprove(2)"
              >Bulk Disapprove</el-button
            >
          </template>
        </div>
      </el-col>
    </el-row>

    <el-dialog :visible.sync="viewDialog">
      <el-form :model="request" :rules="formRules" ref="approveForm">
        <p>
          Are you sure want to approve this request?
        </p>
        <el-form-item label="Request Quantity" prop="quantity">
          <!-- <el-input
            type="number"
            v-model.number="request.quantity"
            oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');"
          ></el-input> -->
          <el-input-number
            v-model.number="request.quantity"
            :controls="false"
          ></el-input-number>
        </el-form-item>
      </el-form>
      <template slot="footer">
        <el-button @click="viewDialog = false" size="mini" :disabled="isLoading"
          >No</el-button
        >
        <el-button
          type="primary"
          @click="submitForm()"
          size="mini"
          :disabled="isLoading"
          >Yes</el-button
        >
      </template>
    </el-dialog>
  </div>
</template>

<script>
import api from "@/api";
import Request from "@/models/StockRequest";
export default {
  name: "request_list",
  computed: {
    is_admin() {
      return this.$store.getters["auth/user"].user_type == 1 ? true : false;
    },
    list() {
      return this.$store.getters["stockrequest/list"];
    },
    glossary() {
      return this.$store.getters["part/glossary"];
    }
  },
  data() {
    return {
      isLoading: false,
      isWithSelection: false,
      request: {
        quantity: 0
      },
      formRules: Request.rules(),
      viewDialog: false,
      pager: {
        page: 1,
        limit: 10,
        search: "",
        status: "all"
      }
    };
  },
  mounted() {
    this.fetch(1);
    this.$store.dispatch("part/getGlossary");
  },
  methods: {
    fetch(page) {
      this.pager.page = page;
      this.isLoading = true;
      // var params = { ...this.pager.page };
      // if (!this.pager.search) delete params.search;
      this.$store.dispatch("stockrequest/getList", this.pager).then(() => {
        this.isLoading = false;
      });
    },
    download() {
      var reportInfo = {
          name: "Approved Request",
          ext: ".csv"
      };
      let url = `/api/v1/purchase/view_request_item/?download=1&limit=-1`
      api.download(url, reportInfo).then(() => {
          this.isLoading = false;
          this.btnDisable = false;
      });
    },
    validateAccess() {
      var isValid = false;
      var user = this.$store.getters["auth/user"];
      if (user.user_type == 1) isValid = true;
      return isValid;
    },
    submitForm() {
      this.$refs["approveForm"].validate(valid => {
        if (!valid) return false;
        this.isLoading = true;
        this.$store
          .dispatch("stockrequest/approve", {
            id: this.request.id,
            quantity: this.request.quantity,
            status: 1
          })
          .then(() => {
            this.viewDialog = false;
            this.request = {};
            this.isLoading = false;
            this.$notify({
              type: "success",
              message: "Stock Request approved.",
              position: "bottom-right"
            });
          });
      });
    },
    itemApprove(req, status) {
      var type = status == 1 ? "approve" : "disapprove";
      if (status == 1) {
        this.request = { ...req };
        this.viewDialog = true;
      } else {
        this.$confirm(`Are you sure you want to ${type} this request?`, {
          confirmButtonText: "Yes",
          cancelButtonText: "No"
        })
          .then(() => {
            this.isLoading = true;
            this.$store
              .dispatch("stockrequest/approve", {
                id: req.id,
                quantity: req.quantity,
                status: status
              })
              .then(() => {
                this.$notify({
                  type: "success",
                  message: "Stock Request disapproved.",
                  position: "bottom-right"
                });
                this.isLoading = false;
              });
          })
          .catch(() => {});
      }
    },
    handleSelectionChange(selection) {
      if (selection.length != 0) this.isWithSelection = true;
      else this.isWithSelection = false;
    },
    verify(row) {
      if (row.request_status == "Approved") return false;
      else return true;
    },
    bulkApprove(status) {
      var type = status == 1 ? "approve" : "disapprove";
      this.$confirm(
        `Are you sure you want to ${type} all the selected stock request?`,
        {
          confirmButtonText: "Yes",
          cancelButtonText: "No"
        }
      )
        .then(() => {
          var list = this.$refs.dataTable.selection;
          if (list.length != 0) {
            var ids = [];
            for (let item of list) {
              ids.push(item.id);
            }
            this.isLoading = true;
            var obj = {
              ids: ids.toString(),
              status: status
            };
            Request.bulkApprove(obj).then(resp => {
              this.isLoading = false;
              if (resp && resp.code == 200) {
                this.$notify({
                  type: "success",
                  message: `Bulk ${type} successful.`,
                  position: "bottom-right"
                });
                this.fetch(1);
              }
            });
          }
        })
        .catch(() => {
          this.$refs.dataTable.clearSelection();
        });
    },
    deleteRequest(id) {
      this.processDelete(id);
    },
    deleteMultiple() {
      var list = this.$refs.dataTable.selection;
      console.log(list);
    },
    processDelete(ids) {
      this.$confirm(
        "Are you sure you want to delete the selected Stock Requests?"
      )
        .then(() => {
          this.isLoading = true;
          Request.delete(ids).then(resp => {
            if (resp && resp.code == 200) {
              this.$notify({
                type: "success",
                message: "Stock Request deleted successfully.",
                position: "bottom-right"
              });
              this.isLoading = false;
              this.fetch(1);
            }
          });
        })
        .catch(() => {});
    }
  }
};
</script>

<style lang="css">
.el-message-box__input {
  padding-top: 0px;
}
</style>
